import React, { useState } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { 
  ArrowLeft, CheckCircle2, Brain, Home,
  ChevronRight, Trophy, Star, RefreshCw
} from 'lucide-react';

// Quiz data organized by airline
const quizData = {
  general: {
    name: 'Genel Mülakat',
    emoji: '🎯',
    color: 'from-blue-500 to-indigo-600',
    questions: [
      {
        q: 'Kendinizi tanıtır mısınız?',
        hint: 'Profesyonel geçmiş + neden kabin memurluğu',
        sampleAnswer: 'Merhaba, ben [İsim]. [Üniversite/Deneyim] ardından havacılık sektörüne olan tutkum beni buraya getirdi. İnsanlarla iletişim kurmayı, farklı kültürlerle tanışmayı seviyorum. Müşteri hizmetleri deneyimim ve takım çalışması becerilerim bu rolde başarılı olmamı sağlayacak.',
        tips: ['30-60 saniye arası olmalı', 'Havacılık tutkusunu vurgula', 'İletişim becerilerini öne çıkar']
      },
      {
        q: 'Neden kabin memuru olmak istiyorsunuz?',
        hint: 'Tutku + Beceriler + Hedefler',
        sampleAnswer: 'Çocukluğumdan beri uçaklara ve seyahate tutkuluyum. İnsanlara yardım etmek beni mutlu ediyor. Kabin memurluğu bu iki tutkumu birleştiren ideal bir kariyer. Ayrıca farklı kültürlerle tanışma ve kendimi geliştirme fırsatı sunuyor.',
        tips: ['Samimi ol', 'Sadece "seyahat" deme, derinleştir', 'Müşteri hizmeti vurgusu']
      },
      {
        q: 'Zor bir müşteriyle nasıl başa çıkarsınız?',
        hint: 'STAR tekniği kullan',
        sampleAnswer: 'Önce sakin kalır ve müşteriyi dinlerim. Empati kurarak sorununu anlamaya çalışırım. "Sizi anlıyorum, bu durum sinir bozucu olabilir" derim. Sonra çözüm üretirim. Eğer yetkim dışındaysa, bir üstüme danışırım. Önemli olan müşterinin duyulduğunu hissetmesi.',
        tips: ['Sakinlik vurgusu', 'Empati göster', 'Çözüm odaklı ol']
      },
      {
        q: 'Takım çalışmasını nasıl tanımlarsınız?',
        hint: 'İşbirliği + Rol paylaşımı + Hedef',
        sampleAnswer: 'Takım çalışması, ortak bir hedefe ulaşmak için birlikte çalışmaktır. Herkesin güçlü yönlerini kullanması, birbirine destek olması gerekir. Kabin ekibinde bu hayati önem taşır - güvenlik, hizmet kalitesi hepimizin sorumluluğu.',
        tips: ['Somut örnek ver', 'Kabin ekibi bağlamında konuş', 'Güvenlik vurgusu']
      },
      {
        q: 'Stresli durumlarla nasıl başa çıkarsınız?',
        hint: 'Sakinlik + Öncelik belirleme + Aksiyon',
        sampleAnswer: 'Stresli durumlarda önce derin nefes alır, sakinleşirim. Sonra durumu değerlendirir, öncelikleri belirlerim. Acil güvenlik sorunu varsa önce onu çözerim. Panik yapmadan, adım adım ilerlerim. Eğitimime güvenirim.',
        tips: ['Soğukkanlılık önemli', 'Güvenlik öncelikli', 'Somut örnek ver']
      }
    ]
  },
  thy: {
    name: 'THY Soruları',
    emoji: '🇹🇷',
    color: 'from-red-500 to-rose-600',
    questions: [
      {
        q: 'Neden THY\'de çalışmak istiyorsunuz?',
        hint: 'THY\'nin özellikleri + Kişisel hedefler',
        sampleAnswer: 'THY, dünyanın en çok ülkesine uçan havayolu. Bu prestij beni çekiyor. Türk misafirperverliğini dünyaya taşımak istiyorum. THY\'nin eğitim programları ve kariyer fırsatları da benim için önemli. 5 yıldızlı hizmet anlayışı ile kendimi geliştirmek istiyorum.',
        tips: ['126+ ülke bilgisi', 'Türk misafirperverliği', 'Kariyer hedefleri']
      },
      {
        q: 'THY\'nin kaç destinasyona uçtuğunu biliyor musunuz?',
        hint: 'Güncel rakamları araştır',
        sampleAnswer: 'THY, 126\'dan fazla ülkede 340\'tan fazla destinasyona uçuyor. Bu sayı ile dünyanın en çok ülkesine uçan havayolu konumunda. Bu rakamlar sürekli artıyor çünkü THY hızla büyüyen bir havayolu.',
        tips: ['Güncel rakamları bil', 'En çok ülke vurgusu', 'Büyüme hızı']
      },
      {
        q: 'Video mülakatımızı izlediniz mi? Ne düşünüyorsunuz?',
        hint: 'Dikkatli dinle, olumlu yorum yap',
        sampleAnswer: 'Evet, video mülakatı çok profesyonel buldum. Soruların işin gerçekliğini yansıttığını düşünüyorum. Özellikle senaryo soruları, bir kabin memurunun günlük karşılaşacağı durumları gösteriyor. Bu hazırlığı daha iyi yapma fırsatı verdi.',
        tips: ['Videoyu gerçekten izle', 'Olumlu görüş bildir', 'Spesifik detay ver']
      },
      {
        q: 'İstanbul dışında konuşlanmaya hazır mısınız?',
        hint: 'Esneklik göster',
        sampleAnswer: 'Evet, tamamen hazırım. THY\'nin Ankara, İzmir, Antalya gibi üslerinde çalışmak benim için sorun değil. Aslında farklı şehirlerde yaşamak, o şehirleri tanımak benim için heyecan verici. Esneklik bu işin doğasında var.',
        tips: ['Kesinlikle evet de', 'Esnekliği vurgula', 'Olumlu bir tavır sergile']
      },
      {
        q: 'THY\'nin değerlerini biliyor musunuz?',
        hint: 'Araştırma yap',
        sampleAnswer: 'THY\'nin temel değerleri: Güvenlik, müşteri odaklılık, Türk misafirperverliği ve sürekli gelişim. "Widen Your World" sloganı ile dünyayı birbirine bağlama misyonu var. Sürdürülebilirlik ve çevreye duyarlılık da önemli değerler arasında.',
        tips: ['Misyon/vizyon bil', 'Slogan: Widen Your World', 'Sürdürülebilirlik vurgusu']
      }
    ]
  },
  pegasus: {
    name: 'Pegasus Soruları',
    emoji: '🟡',
    color: 'from-yellow-500 to-orange-500',
    questions: [
      {
        q: 'Low-cost havayolu size ne ifade ediyor?',
        hint: 'Verimlilik + Müşteri değeri',
        sampleAnswer: 'Low-cost, düşük kalite değil, verimli operasyon demek. Gereksiz masrafları kesip, tasarrufu yolcuya yansıtmak. Pegasus bunu başarıyla yapıyor - uygun fiyat ama kaliteli hizmet. Quick turnaround, optimize edilmiş süreçler önemli.',
        tips: ['Verimlilik vurgusu', 'Düşük kalite DEĞİL', 'Hızlı dönüş süresi']
      },
      {
        q: 'Hızlı dönüş süresinde nasıl çalışırsınız?',
        hint: 'Hız + Kalite dengesi',
        sampleAnswer: '25 dakikalık turnaround\'da her saniye önemli. Yolcu inmeden hazırlık başlar - çöp toplama, kemer kontrolü. Öncelik güvenlik ve temizlik. Hızlı ama panik yok. Takım olarak koordineli çalışırız. Verimlilik Pegasus\'un DNA\'sında.',
        tips: ['25 dakika turnaround', 'Koordinasyon önemli', 'Güvenlik hep önce']
      },
      {
        q: 'Neden THY değil Pegasus?',
        hint: 'Pegasus\'un özellikleri',
        sampleAnswer: 'Pegasus dinamik, hızlı büyüyen bir şirket. Genç ve enerjik ekip yapısı bana uygun. Low-cost modelin zorluğu ve heyecanı beni çekiyor. Ayrıca Sabiha Gökçen üssü İstanbul\'un Avrupa yakasından daha ulaşılabilir.',
        tips: ['Dinamik yapı', 'Genç ekip', 'Büyüme hızı']
      }
    ]
  },
  emirates: {
    name: 'Emirates Soruları',
    emoji: '🇦🇪',
    color: 'from-red-600 to-red-800',
    questions: [
      {
        q: 'Are you willing to relocate to Dubai?',
        hint: 'Kesin ve olumlu cevap',
        sampleAnswer: 'Absolutely! Living in Dubai would be an incredible opportunity. I am excited about experiencing a new culture, meeting people from all over the world, and building my career with Emirates. I have no hesitation about relocating.',
        tips: ['Kesin EVET', 'Heyecan göster', 'Tereddüt yok']
      },
      {
        q: 'What do you know about Emirates?',
        hint: 'Araştırma önemli',
        sampleAnswer: 'Emirates is the largest airline in the Middle East, based in Dubai. Known for luxury service, especially on A380 flights. They fly to over 150 destinations. Emirates has won numerous awards including World\'s Best Airline. The company is known for excellent crew training.',
        tips: ['A380 filosu', 'Dubai hub', 'Ödüller ve prestij']
      },
      {
        q: 'How would you handle a passenger who is afraid of flying?',
        hint: 'Empati + Aksiyon',
        sampleAnswer: 'First, I would approach them calmly and acknowledge their fear - it\'s very common. I would offer reassurance about the safety of flying. Practical help like extra water, breathing techniques, or distraction through conversation can help. I would check on them regularly throughout the flight.',
        tips: ['Empati göster', 'Pratik çözümler', 'Düzenli kontrol']
      }
    ]
  }
};

export default function InterviewQuizPractice({ onBack }) {
  const [selectedAirline, setSelectedAirline] = useState(null);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [showAnswer, setShowAnswer] = useState(false);
  const [userRating, setUserRating] = useState(null);
  const [completedQuestions, setCompletedQuestions] = useState([]);
  const [quizCompleted, setQuizCompleted] = useState(false);

  const airlines = Object.entries(quizData).map(([key, value]) => ({
    id: key,
    ...value
  }));

  const airlineKeys = Object.keys(quizData);

  const handleRating = (rating) => {
    setUserRating(rating);
    setCompletedQuestions([...completedQuestions, { 
      question: currentQuestion, 
      rating 
    }]);
  };

  const nextQuestion = () => {
    const questions = quizData[selectedAirline].questions;
    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
      setShowAnswer(false);
      setUserRating(null);
    } else {
      // Quiz completed
      setQuizCompleted(true);
    }
  };

  const resetQuiz = () => {
    setCurrentQuestion(0);
    setShowAnswer(false);
    setUserRating(null);
    setCompletedQuestions([]);
    setQuizCompleted(false);
  };

  const goToNextAirline = () => {
    const currentIndex = airlineKeys.indexOf(selectedAirline);
    if (currentIndex < airlineKeys.length - 1) {
      setSelectedAirline(airlineKeys[currentIndex + 1]);
      resetQuiz();
    }
  };

  const goToPrevAirline = () => {
    const currentIndex = airlineKeys.indexOf(selectedAirline);
    if (currentIndex > 0) {
      setSelectedAirline(airlineKeys[currentIndex - 1]);
      resetQuiz();
    }
  };

  // Airline selection screen
  if (!selectedAirline) {
    return (
      <div className="min-h-screen bg-gray-50 pb-8">
        <div className="bg-gradient-to-br from-blue-600 to-indigo-600 px-4 pt-6 pb-8 rounded-b-[2rem]">
          <div className="max-w-4xl mx-auto">
            <button 
              onClick={onBack}
              className="flex items-center gap-2 text-white/80 hover:text-white mb-4"
            >
              <Home className="w-5 h-5" />
              <span className="font-medium">Pratik Merkezi</span>
            </button>
            
            <div className="text-center text-white">
              <Brain className="w-12 h-12 mx-auto mb-2 text-yellow-300" />
              <h1 className="text-2xl font-bold">Soru-Cevap Pratiği</h1>
              <p className="text-blue-100 text-sm mt-1">Havayoluna göre mülakat soruları</p>
            </div>
          </div>
        </div>

        <div className="max-w-4xl mx-auto px-4 mt-6">
          <h2 className="text-lg font-bold text-gray-800 mb-4">Havayolu Seç</h2>
          
          <div className="grid grid-cols-2 gap-4">
            {airlines.map((airline) => (
              <Card 
                key={airline.id}
                className="cursor-pointer hover:shadow-lg transition-all hover:scale-[1.02]"
                onClick={() => setSelectedAirline(airline.id)}
              >
                <CardContent className="p-4 text-center">
                  <div className={`w-16 h-16 mx-auto rounded-full bg-gradient-to-br ${airline.color} flex items-center justify-center mb-3`}>
                    <span className="text-3xl">{airline.emoji}</span>
                  </div>
                  <h3 className="font-bold text-gray-900">{airline.name}</h3>
                  <p className="text-sm text-gray-500 mt-1">{airline.questions.length} soru</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    );
  }

  // Quiz completion screen
  if (quizCompleted) {
    const airline = quizData[selectedAirline];
    const currentIndex = airlineKeys.indexOf(selectedAirline);
    const hasNext = currentIndex < airlineKeys.length - 1;
    const hasPrev = currentIndex > 0;
    const avgRating = completedQuestions.length > 0 
      ? (completedQuestions.reduce((a, b) => a + b.rating, 0) / completedQuestions.length).toFixed(1)
      : 0;

    return (
      <div className="min-h-screen bg-gray-50 pb-8">
        <div className={`bg-gradient-to-br ${airline.color} px-4 pt-6 pb-8 rounded-b-[2rem]`}>
          <div className="max-w-4xl mx-auto text-center text-white">
            <Trophy className="w-16 h-16 mx-auto mb-2 text-yellow-300" />
            <h1 className="text-2xl font-bold">Quiz Tamamlandı!</h1>
            <p className="text-white/80 text-sm mt-1">{airline.name}</p>
          </div>
        </div>

        <div className="max-w-4xl mx-auto px-4 mt-6">
          {/* Stats */}
          <Card className="mb-6">
            <CardContent className="p-6 text-center">
              <div className="text-6xl mb-4">🎉</div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">Tebrikler!</h2>
              <p className="text-gray-600 mb-4">{airline.questions.length} soruyu tamamladın</p>
              
              <div className="flex justify-center gap-6 mb-6">
                <div className="text-center">
                  <div className="text-3xl font-bold text-green-600">{completedQuestions.length}</div>
                  <div className="text-sm text-gray-500">Cevaplanan</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-yellow-600">{avgRating}</div>
                  <div className="text-sm text-gray-500">Ortalama Puan</div>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Navigation Options */}
          <div className="space-y-3">
            <Button onClick={resetQuiz} variant="outline" className="w-full py-6">
              <RefreshCw className="w-5 h-5 mr-2" />
              {airline.name} - Tekrar Çöz
            </Button>

            {hasPrev && (
              <Button 
                variant="outline" 
                className="w-full py-6"
                onClick={goToPrevAirline}
              >
                <ArrowLeft className="w-5 h-5 mr-2" />
                Önceki: {quizData[airlineKeys[currentIndex - 1]].name}
              </Button>
            )}

            {hasNext && (
              <Button 
                className="w-full py-6 bg-gradient-to-r from-blue-600 to-indigo-600"
                onClick={goToNextAirline}
              >
                Sonraki: {quizData[airlineKeys[currentIndex + 1]].name}
                <ChevronRight className="w-5 h-5 ml-2" />
              </Button>
            )}

            <Button 
              variant="outline" 
              className="w-full py-6"
              onClick={() => setSelectedAirline(null)}
            >
              Tüm Havayolları
            </Button>

            <Button 
              variant="outline" 
              className="w-full py-6"
              onClick={onBack}
            >
              <Home className="w-5 h-5 mr-2" />
              Pratik Merkezi'ne Dön
            </Button>
          </div>
        </div>
      </div>
    );
  }

  // Quiz screen
  const airline = quizData[selectedAirline];
  const question = airline.questions[currentQuestion];
  const progress = ((currentQuestion + 1) / airline.questions.length) * 100;
  const isLastQuestion = currentQuestion >= airline.questions.length - 1;

  return (
    <div className="min-h-screen bg-gray-50 pb-8">
      <div className={`bg-gradient-to-br ${airline.color} px-4 pt-6 pb-8 rounded-b-[2rem]`}>
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center justify-between mb-4">
            <button 
              onClick={() => setSelectedAirline(null)}
              className="flex items-center gap-2 text-white/80 hover:text-white"
            >
              <Home className="w-5 h-5" />
              <span className="font-medium">Havayolları</span>
            </button>
            
            <div className="flex items-center gap-2 bg-white/20 backdrop-blur px-3 py-1.5 rounded-full">
              <span className="text-xl">{airline.emoji}</span>
              <span className="text-white font-bold text-sm">{airline.name}</span>
            </div>
          </div>

          <div className="bg-white/20 rounded-full h-2 mb-2">
            <div 
              className="bg-white rounded-full h-2 transition-all duration-300"
              style={{ width: `${progress}%` }}
            />
          </div>
          <p className="text-white/80 text-sm text-center">
            Soru {currentQuestion + 1} / {airline.questions.length}
          </p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 mt-6">
        {/* Question Card */}
        <Card className="mb-4">
          <CardContent className="p-6">
            <h2 className="text-xl font-bold text-gray-900 mb-4">{question.q}</h2>
            
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mb-4">
              <p className="text-sm text-yellow-800">
                <strong>💡 İpucu:</strong> {question.hint}
              </p>
            </div>

            {!showAnswer ? (
              <div className="text-center py-8">
                <p className="text-gray-500 mb-4">Cevabınızı düşünün, sonra örnek cevabı görün</p>
                <Button 
                  onClick={() => setShowAnswer(true)}
                  className="bg-gradient-to-r from-blue-600 to-indigo-600"
                >
                  Örnek Cevabı Göster
                </Button>
              </div>
            ) : (
              <div className="space-y-4">
                <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                  <h3 className="font-semibold text-green-800 mb-2">✅ Örnek Cevap:</h3>
                  <p className="text-gray-700">{question.sampleAnswer}</p>
                </div>

                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                  <h3 className="font-semibold text-blue-800 mb-2">📝 Dikkat Edilmesi Gerekenler:</h3>
                  <ul className="space-y-1">
                    {question.tips.map((tip, i) => (
                      <li key={i} className="text-sm text-gray-700 flex items-center gap-2">
                        <CheckCircle2 className="w-4 h-4 text-blue-600" />
                        {tip}
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Self Rating */}
                {!userRating && (
                  <div className="bg-purple-50 border border-purple-200 rounded-lg p-4">
                    <h3 className="font-semibold text-purple-800 mb-3">Kendi cevabını değerlendir:</h3>
                    <div className="flex justify-center gap-3">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <button
                          key={star}
                          onClick={() => handleRating(star)}
                          className="p-2 hover:scale-110 transition-transform"
                        >
                          <Star className={`w-8 h-8 ${star <= (userRating || 0) ? 'fill-yellow-400 text-yellow-400' : 'text-gray-300'}`} />
                        </button>
                      ))}
                    </div>
                  </div>
                )}

                {/* Navigation - Always visible after showing answer */}
                <div className="flex justify-between items-center pt-4 border-t">
                  <div className="flex items-center gap-2">
                    {userRating && (
                      <>
                        <Trophy className="w-5 h-5 text-yellow-500" />
                        <span className="text-sm text-gray-600">Değerlendirmen: {userRating}/5</span>
                      </>
                    )}
                  </div>
                  
                  <Button onClick={nextQuestion} className="bg-gradient-to-r from-blue-600 to-indigo-600">
                    {isLastQuestion ? 'Quizi Bitir' : 'Sonraki Soru'}
                    <ChevronRight className="w-4 h-4 ml-1" />
                  </Button>
                </div>
              </div>
            )}
          </CardContent>
        </Card>

        {/* Completed Stats */}
        {completedQuestions.length > 0 && (
          <Card className="bg-gradient-to-r from-purple-50 to-pink-50 border-purple-200">
            <CardContent className="p-4">
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-gray-800">{completedQuestions.length} soru tamamlandı</p>
                  <p className="text-sm text-gray-600">
                    Ortalama: {(completedQuestions.reduce((a, b) => a + b.rating, 0) / completedQuestions.length).toFixed(1)}/5
                  </p>
                </div>
                <Trophy className="w-8 h-8 text-yellow-500" />
              </div>
            </CardContent>
          </Card>
        )}
      </div>
    </div>
  );
}
